export default __webpack_public_path__ + "static/media/logo-with_Australia.e43b9f7d.png";